module.exports = __webpack_public_path__ + "static/media/refundArrow.8b650faf.svg";